import './styles/WatchlistList.scss';

import { Grid, Paper } from '@mui/material';
import { GridSortModel } from '@mui/x-data-grid';

import { useState, useDeferredValue, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCategoriesQuery } from 'api/hooks/users/categories';
import { useWatchlistListQuery } from 'api/hooks/watchlist';
import { Filter, Filters } from 'app/components';
import { DataGrid } from 'app/components/DataGrid';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { useWatchlistColumns } from '../Hooks/useWatchlistColumns';

export const WatchlistList = () => {
  const { t } = useTranslation();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0
  });
  const categoryFilter = useState([]);
  const searchString = useState('');
  const [offset, setOffset] = useState(0);

  const deferedOffset = useDeferredValue(offset);
  const deferedPageSize = useDeferredValue(paginationModel.pageSize);
  const deferedSearchString = useDeferredValue(searchString[0]);
  const deferedCategoryFilter = useDeferredValue(categoryFilter[0]);
  const [sortingmodel, setSortingModel] = useState<GridSortModel>([
    { field: 'createdAt', sort: 'desc' }
  ]);

  const { data: watchlistData, isLoading: watchlistLoading } = useWatchlistListQuery({
    params: {
      text: deferedSearchString,
      category: deferedCategoryFilter,
      skip: deferedOffset,
      take: deferedPageSize,
      sort: sortingmodel[0]?.field,
      sortOrder: sortingmodel[0]?.sort
    }
  });
  const {
    query: { data: categoriesData, isLoading: categoryLoading }
  } = useCategoriesQuery();

  const columns = useWatchlistColumns();

  const handleSortModelChange = useCallback((model: GridSortModel) => {
    setSortingModel(model);
  }, []);

  const filters: Filter[] = [
    {
      field: 'search',
      label: t(translations.common.search()),
      stateHandler: searchString
    },
    {
      field: 'category',
      label: t(translations.pages.watchlist.columns.category()),
      select: {
        options: [
          {
            //label to remove Filter and show all entries
            label: '---',
            name: null
          },
          ...categoriesData
            .map(category => {
              return {
                label: t(translations.layout.categories[category.name]()),
                name: category.name
              };
            })
            .sort((a: { label: string; name: string }, b: { label: string; name: string }) => {
              //sort asc
              return a.label > b.label ? 1 : -1;
            })
        ],
        stateHandler: categoryFilter
      }
    }
  ];

  usePageHeading({
    heading: t(translations.pages.watchlist.title()),
    mobilePadding: false
  });

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Filters filterConfig={filters} />
        </Grid>
      </Grid>
      <Grid container component={Paper} style={{ height: '80vh' }}>
        <DataGrid
          columns={columns}
          rows={watchlistData?.data || []} //TODO Remove empty Array when Flickering on SortUpdate is fixed
          style={{ height: '100%', width: '100%' }}
          rowCount={watchlistData?.count || 0}
          paginationMode="server"
          paginationModel={{ page: paginationModel.page, pageSize: paginationModel.pageSize }}
          onPaginationModelChange={pagModel => {
            setPaginationModel(pagModel);
            setOffset(pagModel.page * pagModel.pageSize);
          }}
          // pageSize={pageSize}
          // onPageSizeChange={pageSize => setPageSize(pageSize)}
          // onPageChange={page => setOffset(page * pageSize)}
          sortingMode="server"
          loading={watchlistLoading || categoryLoading}
          disableColumnMenu={true}
          onSortModelChange={handleSortModelChange}
        />
      </Grid>
    </>
  );
};
